export function splitThreadExecution<T extends any[]>({
  uiCallback, // Function to update UI immediately.
  mainCallback, // Function to run after yielding to main thread.
}: {
  uiCallback?: (...args: T) => void;
  mainCallback?: (...args: T) => void;
} = {}) {
  return async (...args: T): Promise<void> => {
    // Persist React synthetic events if present.
    if (args[0]?.persist?.()) {
      args[0].persist();
    }

    requestAnimationFrame(() => {
      uiCallback?.(...args);

      setTimeout(() => {
        mainCallback?.(...args);
      }, 0);
    });
  };
}
